export default "__VITE_ASSET__CfLD0svd__"